<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Bundle Package</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Bundle Package</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="BundlePackage">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-header">
            <h3 class="card-title" v-if="!is_edit">Create</h3>
            <h3 class="card-title" v-if="is_edit">Edit</h3>
            <div class="card-tools">
              <router-link
                class="btn btn-info"
                :to="{ name: 'BundlePackageList' }"
              >
                <i class="fas fa-list"></i> List
              </router-link>
            </div>
          </div>
          <div class="card-body">
            <el-tabs>
              <el-tab-pane label="Bundle Package">
                <form
                  @submit.prevent="handleSubmission()"
                  method="POST"
                  novalidate
                >
                  <div class="row">
                    <div class="col-8">
                      <div class="form-group required">
                        <label class="control-label"
                        >Bundle Title (English)</label
                        >
                        <input
                          type="text"
                          id="bundle_title"
                          name="bundle_title"
                          @change="slug"
                          v-bind:class="{
                            'has-error': errors.has('bundle_title'),
                          }"
                          v-validate="'required'"
                          v-model="value.bundle_title"
                          class="form-control bundle_title"
                          placeholder="Bundle Title (English)"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('bundle_title')"
                        >
                          {{ errors.first("bundle_title") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label"
                        >Bundle Title (Bangla)</label
                        >
                        <input
                          type="text"
                          id="bundle_title_bn"
                          name="bundle_title_bn"
                          v-bind:class="{
                            'has-error': errors.has('bundle_title_bn'),
                          }"
                          v-model="value.bundle_title_bn"
                          class="form-control"
                          placeholder="Bundle Title (Bangla)"
                        />
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Slug / URL</label>
                        <input
                          type="text"
                          id="slug"
                          name="slug"
                          v-bind:class="{ 'has-error': errors.has('slug') }"
                          v-validate="'required'"
                          v-model="value.slug"
                          class="form-control"
                          placeholder="Slug / URL"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('slug')"
                        >
                          {{ errors.first("slug") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Course</label>
                        <multiselect
                          id="courses"
                          name="courses"
                          :options="Object.keys(pre.courses)"
                          :custom-label="(opt) => pre.courses[opt]"
                          v-bind:class="{ 'has-error': errors.has('courses') }"
                          v-validate="'required'"
                          v-model="bundle_courses"
                          class="courses"
                          placeholder="Select Course"
                          :searchable="true"
                          :multiple="true"
                          :close-on-select="true"
                          :show-labels="false"
                        ></multiselect>
                        <div
                          class="help text-danger"
                          v-show="errors.has('courses')"
                        >
                          {{ errors.first("courses") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Summary (English)</label>
                        <textarea
                          id="summary"
                          name="summary"
                          v-bind:class="{ 'has-error': errors.has('summary') }"
                          v-validate="'required'"
                          v-model="value.summary"
                          class="form-control summary"
                          placeholder="Summary"
                          rows="3"
                        ></textarea>
                        <div
                          class="help text-danger"
                          v-show="errors.has('summary')"
                        >
                          {{ errors.first("summary") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Summary (Bangla)</label>
                        <textarea
                          id="summary_bn"
                          name="summary_bn"
                          v-bind:class="{
                            'has-error': errors.has('summary_bn'),
                          }"
                          v-model="value.summary_bn"
                          class="form-control summary_bn"
                          placeholder="Summary (Bangla)"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label class="control-label"
                        >Description (English)</label
                        >
                        <ckeditor
                          id="description"
                          name="description"
                          v-model="value.description"
                          placeholder="Description (English)"
                        ></ckeditor>
                      </div>
                      <div class="form-group">
                        <label class="control-label"
                        >Description (Bangla)</label
                        >
                        <ckeditor
                          id="description_bn"
                          name="description_bn"
                          v-model="value.description_bn"
                          placeholder="Description (Bangla)"
                        ></ckeditor>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Category</label>
                        <multiselect
                          id="category_id"
                          name="category_id"
                          :options="Object.keys(pre.category_id)"
                          :custom-label="(opt) => pre.category_id[opt]"
                          v-bind:class="{
                            'has-error': errors.has('category_id'),
                          }"
                          v-validate="'required'"
                          v-model="value.category_id"
                          class="category_id"
                          placeholder="Select Category"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                        ></multiselect>
                        <div
                          class="help text-danger"
                          v-show="errors.has('category_id')"
                        >
                          {{ errors.first("category_id") }}
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>Bundle Image Path</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="bundle_image_path"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  v-bind:class="{
                                    'has-error':
                                      errors.has('bundle_image_path'),
                                  }"
                                  name="bundle_image_path"
                                  class="custom-file-input"
                                  id="bundle_image_path"
                                  accept="image/png, image/jpeg, image/jpg"
                                  @change="selectFile($event, 'image')"
                                />
                                <label
                                  class="custom-file-label"
                                  for="bundle_image_path"
                                >Choose file</label
                                >
                              </div>
                            </div>
                          </div>
                          <div
                            class="form-group"
                            v-if="value.bundle_image_path_name"
                          >
                            <img
                              alt="preview image"
                              :src="value.bundle_image_path"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                            {{ value.bundle_image_path_name }}
                            &nbsp;
                            <i
                              class="fas fa-window-close"
                              @click="removeFile('image')"
                            ></i>
                          </div>
                        </div>
                        <span class="help xs-text text-info"
                        >Supported mimes: jpeg, jpg, png</span
                        >
                        <br/>
                        <div
                          class="help text-danger"
                          v-show="errors.has('bundle_image_path')"
                        >
                          {{ errors.first("bundle_image_path") }}
                        </div>
                      </div>

                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>Bundle intro video path</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="bundle_intro_video_path"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  name="bundle_intro_video_path"
                                  class="custom-file-input"
                                  id="bundle_intro_video_path"
                                  accept="video/mp4"
                                  @change="selectFile($event, 'video')"
                                />
                                <label
                                  class="custom-file-label"
                                  for="bundle_intro_video_path"
                                >Choose file</label
                                >
                              </div>
                            </div>
                          </div>
                          <div
                            class="form-group"
                            v-if="value.bundle_intro_video_path_name"
                          >
                            {{ value.bundle_intro_video_path_name }}
                            <i
                              class="fas fa-window-close"
                              @click="removeFile('video')"
                            ></i>
                          </div>
                        </div>
                        <span class="help xs-text text-ingo"
                        >Supported mimes: mp4</span
                        >
                        <br/>
                        <div
                          class="help text-danger"
                          v-show="errors.has('bundle_intro_video_path')"
                        >
                          {{ errors.first("bundle_intro_video_path") }}
                        </div>
                      </div>
                      <!-- <div class="form-group">
                        <label class="control-label">Keyword</label>
                        <input
                          type="text"
                          id="keyword"
                          name="keyword"
                          v-model="value.keyword"
                          class="form-control keyword"
                          placeholder="Keyword"
                        />
                      </div> -->
                      <div class="form-group">
                        <label class="control-label">Tag</label>
                        <multiselect
                          id="tag"
                          name="tag"
                          :options="Object.values(pre.tag)"
                          :custom-label="(opt) => opt"
                          v-bind:class="{ 'has-error': errors.has('tag') }"
                          v-model="selected_tags"
                          class="tag"
                          :multiple="true"
                          placeholder="Select Tag"
                          :searchable="true"
                          :show-labels="false"
                        ></multiselect>
                      </div>
                      <!-- <div class="form-group required">
                        <label class="control-label"
                        >Course Duration(in Minute)</label
                        >
                        <input
                          type="number"
                          min="0"
                          id="course_duration"
                          name="course_duration"
                          v-bind:class="{
                        'has-error': errors.has('course_duration'),
                      }"
                          v-validate="'required'"
                          v-model="value.course_duration"
                          class="form-control course_duration"
                          placeholder="Course Duration(in Minute)"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('course_duration')"
                        >
                          {{ errors.first("course_duration") }}
                        </div>
                      </div> -->
                      <div class="form-group">
                        <label class="control-label">Display Order</label>
                        <input
                          type="number" min="999"
                          id="display_order" name="display_order"
                          v-model="value.display_order"
                          class="form-control display_order"
                          placeholder="Display Order"
                        />
                      </div>
                      <div class="form-group">
                        <label class="control-label">Price</label>
                        <input
                          type="number" min="0" id="price" name="price"
                          v-model="value.price"
                          class="form-control price"
                          placeholder="Price"
                        />
                      </div>
                      <div class="form-group required">
                        <div class="custom-control custom-checkbox">
                          <input
                            class="custom-control-input"
                            type="checkbox" id="is_subscribable"
                            name="is_subscribable"
                            v-model="value.is_subscribable"
                          />
                          <label for="is_subscribable" class="custom-control-label">Is Subscribable?</label>
                        </div>
                      </div>

                      <div class="form-group required">
                        <div class="custom-control custom-checkbox">
                          <input
                            class="custom-control-input" type="checkbox"
                            :id="'is_featured'" name="is_featured" :disabled="value.is_subscribable != 0"
                            v-validate="'required'" v-model="value.is_featured"
                          />
                          <label
                            :for="'is_featured'"
                            class="custom-control-label"
                          >Is Featured?</label
                          >
                        </div>
                      </div>

                      <div class="form-group required">
                        <div class="custom-control custom-checkbox">
                          <input
                            class="custom-control-input"
                            type="checkbox" :id="'is_published'" :disabled="value.is_subscribable != 0"
                            name="is_published" v-validate="'required'"
                            v-model="value.is_published"
                          />
                          <label :for="'is_published'" class="custom-control-label">Is Published?</label>
                        </div>
                      </div>
                      <!-- <div class="form-group">
                        <label class="control-label"
                          >Commission Configuration Id</label
                        >
                        <input
                          type="text"
                          id="commission_configuration_id"
                          name="commission_configuration_id"
                          v-model="value.commission_configuration_id"
                          class="form-control commission_configuration_id"
                          placeholder="Commission Configuration Id"
                        />
                      </div>
                      <div class="form-group">
                        <label class="control-label"
                          >Commission Expire Date</label
                        >
                        <div class="clearfix"></div>
                        <date-picker
                          type="datetime"
                          input-class="form-control"
                          v-model="value.commission_expire_date"
                          lang="en"
                          format="YYYY-MM-DD"
                          value-type="YYYY-MM-DD"
                        ></date-picker>
                      </div> -->
                    </div>
                  </div>
                  <div style="padding-bottom: 2.25rem">
                    <h4 class="site-heading my-3">
                      <span>Feature</span>
                    </h4>
                    <div
                      class="form-row align-items-end"
                      v-for="(
                        bundle_package_feature, index
                      ) in value.bundle_package_features"
                    >
                      <div class="form-group col-md-11 required">
                        <label class="control-label">Title</label>
                        <input
                          type="text"
                          id="bundle_package_feature.title"
                          name="bundle_package_feature.title"
                          v-bind:class="{
                            'has-error': errors.has(
                              'bundle_package_feature.title'
                            ),
                          }"
                          v-validate="'required'"
                          v-model="bundle_package_feature.title"
                          class="form-control bundle_package_feature.title"
                          placeholder="Title"
                        />
                        <div class="help text-danger"
                             v-show="errors.has('bundle_package_feature.title')">
                          {{ errors.first("bundle_package_feature.title") }}
                        </div>
                      </div>
                      <div class="form-group col-md-1">
                        <button type="button"
                                class="btn btn-danger float-right"
                                @click="deleteBundle_package_feature(index)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                    <button type="button"
                            @click="addBundle_package_feature"
                            class="btn btn-success">
                      <i class="fa fa-plus"></i> New
                    </button>
                  </div>
                  <div>
                    <button type="submit" v-if="!is_edit" class="btn btn-primary">
                      Submit
                    </button>
                    <button type="submit" v-if="is_edit" class="btn btn-primary">
                      Update
                    </button>
                  </div>
                </form>
              </el-tab-pane>
              <el-tab-pane label="SEO Meta" v-if="is_edit">
                <form
                  @submit.prevent="handleMetaTagSubmission()"
                  method="POST" novalidate
                >
                  <div class="row">
                    <div class="col-8">
                      <div class="form-group required">
                        <label class="control-label" for="meta_title">Meta title</label>
                        <input
                          type="text" id="meta_title" name="meta_title"
                          v-model="meta.meta_title"
                          class="form-control" placeholder="meta title"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('meta_title')"
                        >
                          {{ errors.first("meta_title") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label" for="meta_keywords"
                        >Meta keywords</label
                        >
                        <input
                          type="text" id="meta_keywords" name="meta_keywords"
                          v-model="meta.meta_keywords"
                          class="form-control" placeholder="meta keywords"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('meta_keywords')"
                        >
                          {{ errors.first("meta_keywords") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label" for="meta_description"
                        >Meta description</label
                        >
                        <input
                          type="text" id="meta_description" name="meta_description"
                          v-model="meta.meta_description"
                          class="form-control" placeholder="meta description"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('meta_description')"
                        >
                          {{ errors.first("meta_description") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label for="meta_image" class="control-label"
                        >Thumbnail</label
                        >
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input type="file" name="meta_image"
                                       class="custom-file-input" id="meta_image"
                                       accept="image/jpeg, image/png, image/jpg"
                                       @change="selectMetaFile"
                                />
                                <label class="custom-file-label" for="meta_image">
                                  {{ meta.temp_meta_thumbnail_name }}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-8">
                            <img
                              alt="preview" v-if="temp_meta_thumbnail"
                              v-bind:src="temp_meta_thumbnail"
                              width="100" height="100" class="img-thumbnail"
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        <button type="submit" v-if="!is_edit" class="btn btn-primary">
                          Submit
                        </button>
                        <button type="submit" v-if="is_edit" class="btn btn-primary">
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "BundlePackageForm",
  metaInfo: {
    title: "BundlePackage | Dotlines",
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    temp_meta_thumbnail: '',
    meta: {
      seoable_id: "",
      temp_meta_thumbnail_name: '',
    },
    bundle_courses: [],
    selected_tags: [],
    value: {
      bundle_package_features: [],
      bundle_image_path: "",
      bundle_image_path_name: "",
      bundle_intro_video_path: "",
      bundle_intro_video_path_name: "",
      tag: [],
      courses: [],
      is_subscribable: 0,
      is_published: 0,
      is_featured: 0,
      display_order: 999,
      price: 0,
    },
    fileName: {
      image: null,
      video: null,
    },
    pre: {
      courses: [],
      category_id: {},
      tag: [],
    },
  }),
  methods: {
    selectFile: function (event, type) {
      this.is_loading = true;
      try {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          switch (type) {
            case "image":
              this.value.bundle_image_path = reader.result;
              this.value.bundle_image_path_name = event.target.files[0].name;
              break;
            case "video":
              this.value.bundle_intro_video_path = reader.result;
              this.value.bundle_intro_video_path_name =
                event.target.files[0].name;
              break;
          }
          this.is_loading = false;
        };
      } catch (e) {
        //console.log(e);
      }
    },

    removeFile: function (type) {
      switch (type) {
        case "image":
          this.value.bundle_image_path = "";
          this.value.bundle_image_path_name = "";
          break;
        case "video":
          this.value.bundle_intro_video_path_name = "";
          this.value.bundle_intro_video_path = "";
      }
    },

    addBundle_package_feature: function () {
      this.value.bundle_package_features.push({});
    },

    deleteBundle_package_feature: function (index) {
      this.value.bundle_package_features.splice(index, 1);
    },

    coursesOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/8")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    categoryIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/3")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    tagOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/5")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    slug() {
      var title = this.value.bundle_title;
      this.value.slug = title.replace(/\s+/g, "-").toLowerCase()
      // return this.value.slug
    },

    handleSubmission() {
      let _this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          if (_this.bundle_courses) _this.value.courses = _this.bundle_courses
          if (_this.selected_tags) _this.value.tag = _this.selected_tags.toString()

          let api_url = "/bundle_packages"
          let method = "POST"
          if (_this.is_edit) {
            api_url = "/bundle_packages/" + _this.$route.params.id
            method = "PUT"
          }
          axios({
            method: method, url: api_url, data: _this.value,
            headers: {"Content-Type": "application/json"},
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({name: "BundlePackageList"})
            })
            .catch((errors) => {
              _this.$toaster.error(errors.response.data.message)
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            });
        }
      });
    },

    handleMetaTagSubmission() {
      let _this = this
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          axios({
            method: "POST",
            url: "/bundle_packages/sync-metatags",
            data: _this.meta,
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({name: "BundlePackageList"})
            })
            .catch((errors) => {
              _this.$toaster.error(errors.response.data.message)
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            });
        }
      });
    },

    selectMetaFile: function (event) {
      // `files` is always an array because the file input may be in multiple mode
      let reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
        this.temp_meta_thumbnail = reader.result
        this.meta.meta_image = reader.result
        this.$set(this.meta, "temp_meta_thumbnail_name", event.target.files[0].name);
      }
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/bundle_packages/" + id
        axios
          .get(api_url)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error)
          });
      });
    },

    async initialize() {
      this.is_loading = true
      this.params = this.$route.params
      await this.coursesOptions().then((courses) => {
        this.pre.courses = courses
      });
      await this.categoryIdOptions().then((category_id) => {
        this.pre.category_id = category_id
      });
      await this.tagOptions().then((tag) => {
        this.pre.tag = tag
      });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data
            this.value.bundle_image_path = this.API_ASSET_UPLOAD_URL + 'learning/' + this.value.bundle_image_path
            if (!_.isNull(response.data.meta_data)) {
              this.meta = response.data.meta_data
              this.temp_meta_thumbnail = this.API_ASSET_UPLOAD_URL + this.meta.meta_image
              this.meta.meta_image = "";
            } else {
              this.meta.seoable_id = this.params.id
            }
            let courseList = this.value.bundle_courses
            var courses = []
            Object.values(courseList).forEach(function (value) {
              courses.push(value.id)
            });
            this.bundle_courses = courses
            this.selected_tags = this.value.tag ? this.value.tag.split(",") : [];
            //this.value.bundle_image_path = response.data.bundle_image_path;
            var filename = this.value.bundle_image_path
              ? this.value.bundle_image_path.split("images/")
              : [];
            this.value.bundle_image_path_name = filename.length > 0 ? filename[1] : "";
            /*this.value.bundle_image_path = this.value.bundle_image_path
              ? this.API_ASSET_UPLOAD_URL +
              "learning/" +
              this.value.bundle_image_path
              : "";*/
            // this.value.bundle_intro_video_path =
            //   response.data.bundle_intro_video_path;
            var filename = this.value.bundle_intro_video_path
              ? this.value.bundle_intro_video_path.split("videos/")
              : [];
            this.value.bundle_intro_video_path_name =
              filename.length > 0 ? filename[1] : "";
          })
          .catch((error) => {
            console.log(error);
          });
      }

      this.is_loading = false;
    },
  },
  watch: {
    'value.is_subscribable': {
      handler: function (after, before) {
        this.value.is_published = (after == 1) ? 0 : this.value.is_published
        this.value.is_featured = (after == 1) ? 0 : this.value.is_featured
      },
      deep: true
    }
  },
  mounted() {
    this.initialize();
  },
};
</script>
